const getElementAttributes = (element) =>
  Object.values(element.attributes).reduce((accum, { name, value }) => {
    const newAccum = accum;
    newAccum[name] = value;
    return newAccum;
  }, {});

export default getElementAttributes;
